export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10570.7b12ca0c.jpg";